





























































































































































































































































































































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeFidelizacaoStore from '@/components/Backoffice/Store/BackofficeFidelizacaoStore'
import HistoricoSolicitacaoStore from '@/components/HistoricoSolicitacao/Store/HistoricoSolicitacaoStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import { humanTime, displayColorBySituation, displayColorByStatus, displayCategoriaDoPlanoParaFidelizacao, getHospitalAreaName, backofficeRoute } from '@/utils/common'
import { StatusSlaEnum, SituacaoEnum, IRequestMessage, RequestMessage, Loading, AgendamentoCirurgia, AgendamentoSolicitacaoItem, User } from '@/types/_'
import { Autorizacao, PendenciaSolicitacao } from '@/types/core'
import EventBus from '@/plugins/EventBus'
import { IAgrupadorHospital } from '@/types/interfaces/agrupador-hospital'
import AgendamentoBackofficeApi from '@/Apis/Agendamento/Services/AgendamentoBackofficeApi'
import CadastroApi from '@/Apis/Cadastro/Services/CadastroApi'
import { permissionService } from '@/services/permission.service'

@Component({ filters: { humanTime } })
export default class ViewBackofficeFidelizacao extends Vue {
  getSchedulingDate(surgeryRequestInfo: any) {
    let dateStatus = ''

    if (surgeryRequestInfo.situacao.key === 'Cancelada') {
      dateStatus = 'Sem reserva'
    } else if (surgeryRequestInfo.situacaoData.key === 'NovaDataSolicitada') {
      dateStatus = 'Nova data solicitada'
    } else if (surgeryRequestInfo.situacaoData.key === 'SemData') {
      dateStatus = 'Sem data definida'
    } else if (surgeryRequestInfo.dataAgendamentoVirtual) {
      dateStatus = 'Data virtual'
    } else if (surgeryRequestInfo.dataAgendamento) {
      dateStatus = humanTime(surgeryRequestInfo.dataAgendamento)
    } else {
      dateStatus = 'Sem reserva'
    }

    return dateStatus
  }

  $user: User;

  columnSelectionMenu: boolean = false
  readyState: boolean = false
  loadVisualizar: string = ''
  loadVisualizarDrillDown: boolean | string = false
  loadHistorico: string = ''
  solicitacaoId: string = ''
  areaDoHospital: any = getHospitalAreaName()

  isFilteredByAllFidelizationStatuses: boolean = false
  expand: boolean = false
  headers: any[] = [
    { text: '', value: '', sortable: false, active: true },
    { text: 'Paciente', value: 'pacienteNome', sortable: false, active: true },
    { text: 'Médico', value: 'medicoNome', sortable: false, active: true },
    { text: 'Caráter', value: 'carater', sortable: false, active: true },
    { text: 'P&L', value: 'categoriaDoPlanoParaFidelizacao', sortable: false, active: true },
    { text: 'Situação', value: 'situacao', sortable: false, active: true },
    { text: 'Fidelização', value: 'statusFidelizacao', sortable: false, active: true },
    { text: 'Ações', value: 'acoes', sortable: false, active: true, width: '157.41px' },
    { text: 'Data da cirurgia', value: 'dataAgendamento', sortable: false, active: true },
    { text: '', value: '', sortable: false, active: true },
  ]

  hasActiveHeader(value: string) {
    if (value === '') return true
    return this.headers.find(header => header.value === value).active
  }

  autorizacao: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()
  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()
  getRequestMessage: IRequestMessage = new RequestMessage()

  regionalFilterOptions: IAgrupadorHospital[] = []
  especialidadeFilterOptions: { id: string, descricao: string }[] = []

  loadingReq: Loading = {
    status: false,
    text: '',
  }

  @Watch('getAllEtapas')
  onFilterChange(selectedAllFilters: boolean) {
    this.isFilteredByAllFidelizationStatuses = selectedAllFilters
  }

  get loadingHistorico() {
    return this.loadHistorico
  }

  set loadingHistorico(value: string) {
    this.loadHistorico = value
  }

  get analysisSurgeryLoading() {
    return this.loadVisualizar
  }

  set analysisSurgeryLoading(val: string) {
    this.loadVisualizar = val
  }

  get readOnlyLoading() {
    return this.loadVisualizarDrillDown
  }

  set readOnlyLoading(val: boolean | string) {
    this.loadVisualizarDrillDown = val
  }

  get loadingRequest() {
    return this.loadingReq
  }

  set loadingRequest(value: Loading) {
    this.loadingReq = value
  }

  get surgerySolicitationStatus() {
    return this.BackofficeFidelizacaoStore.situacoes
  }

  set surgerySolicitationStatus(status: any) {
    this.BackofficeFidelizacaoStore.setSurgerySolicitationStatus(status.key)
  }

  get drawer() {
    return this.BackofficeFidelizacaoStore.filterDrawer
  }

  set drawer(value: boolean) {
    this.BackofficeFidelizacaoStore.setFilterDrawer(value)
  }

  get etapasBase() {
    return [
      { key: 'analisePreAutorizacao', display: 'Análise pré-autorização', quantidade: this.getAnalisePreAutorizacaoTotal },
      { key: 'analisePreCotacao', display: 'Análise pré-cotação', quantidade: this.getAnalisePreCotacaoTotal },
      { key: 'revisaoCirurgicaAutorizacao', display: 'Revisão Cirúrgica', quantidade: this.getRevisaoCirurgicaAutorizacaoTotal },
      { key: 'aguardandoSuprimentos', display: 'Aguardando suprimentos', quantidade: this.getAguardandoSuprimentosTotal },
      { key: 'emCotacao', display: 'Aguardando cotação', quantidade: this.getEmCotacaoTotal },
      { key: 'incompleta', display: 'Em edição', quantidade: this.getEmEdicaoTotal },
      { key: 'pendente', display: 'Pendência médica', quantidade: this.getPendenteTotal },
      { key: 'pendenteDeEnvioRoboDeAutorizacao', display: 'Pendente de Autorização', quantidade: this.getPendenteDeEnvioRoboDeAutorizacaoTotal },
      { key: 'pendenciaRespondida', display: 'Pendência respondida', quantidade: this.getPendenciaRespondidaTotal },
      { key: 'analisePosCotacao', display: 'Análise pós-cotação', quantidade: this.getAnalisePosCotacaoTotal },
      { key: 'aguardandoOperadora', display: 'Aguardando autorização', quantidade: this.getAguardandoOperadoraTotal },
      { key: 'respostaDoRoboDeAutorizacao', display: 'Retorno da Operadora (Robô)', quantidade: this.getRespostaDoRoboDeAutorizacaoTotal },
      { key: 'retornoDaAutorizacaoDoHis', display: 'Retorno da Operadora (His)', quantidade: this.getRetornoDaAutorizacaoDoHisTotal },
      { key: 'pendenteDeEnvioRoboDeAutorizacao', display: 'Resposta Operadora', quantidade: this.getPendenteDeEnvioRoboDeDaAutorizacaoTotal },
      { key: 'autorizadaParcial', display: 'Autorizada parcial', quantidade: this.getAutorizadaParcialTotal },
      { key: 'autorizacaoPos', display: 'Autorização Pós', quantidade: this.getAutorizacaoPosTotal },
      { key: 'autorizada', display: 'Autorizada', quantidade: this.getAutorizadaTotal },
      { key: 'contestacaoMedica', display: 'Contestação Médica', quantidade: this.getContestacaoTotal },
      { key: 'contestacaoPendente', display: 'Contestação Pendente', quantidade: this.getContestacaoPendenteTotal },
    ]
  }

  get surgerySolicitationStatuses() {
    let status: any = []

    if (permissionService.hasPermission('agendamento.backoffice.fidelizacao.filtrarPorStatusDaAutorizacao')) {
      status = status.concat([
        { key: 'analisePreAutorizacao', display: 'Análise pré-autorização', quantidade: 0 },
        { key: 'analisePreCotacao', display: 'Análise pré-cotação', quantidade: 0 },
        { key: 'revisaoCirurgicaAutorizacao', display: 'Revisão Cirúrgica', quantidade: 0 },
        { key: 'aguardandoSuprimentos', display: 'Aguardando suprimentos', quantidade: 0 },
        { key: 'emCotacao', display: 'Aguardando cotação', quantidade: 0 },
        { key: 'incompleta', display: 'Em edição', quantidade: 0 },
        { key: 'pendente', display: 'Pendência médica', quantidade: 0 },
        { key: 'pendenteDeEnvioRoboDeAutorizacao', display: 'Pendente de Autorização', quantidade: 0 },
        { key: 'pendenciaRespondida', display: 'Pendência respondida', quantidade: 0 },
        { key: 'analisePosCotacao', display: 'Análise pós-cotação', quantidade: 0 },
        { key: 'aguardandoOperadora', display: 'Aguardando autorização', quantidade: 0 },
        { key: 'respostaDoRoboDeAutorizacao', display: 'Retorno da Operadora (Robô)', quantidade: 0 },
        { key: 'retornoDaAutorizacaoDoHis', display: 'Retorno da Operadora (His)', quantidade: 0 },
        { key: 'pendenteDeEnvioRoboDeAutorizacao', display: 'Resposta Operadora', quantidade: 0 },
        { key: 'autorizadaParcial', display: 'Autorizada parcial', quantidade: 0 },
        { key: 'autorizacaoPos', display: 'Autorização Pós', quantidade: 0 },
        { key: 'autorizada', display: 'Autorizada', quantidade: 0 },
        { key: 'contestacaoMedica', display: 'Contestação Médica', quantidade: 0 },
        { key: 'contestacaoPendente', display: 'Contestação Pendente', quantidade: 0 },
      ])
    }

    if (permissionService.hasPermission('agendamento.backoffice.fidelizacao.filtrarPorStatusDoAgendamento')) {
      status = status.concat([
        { key: 'preAgendamento', display: 'Pré-agendamento', quantidade: 0 },
        { key: 'revisaoCirurgica', display: 'Revisão Cirúrgica', quantidade: 0 },
        { key: 'enviado', display: 'Nova solicitação', quantidade: 0 },
        { key: 'pendenciaAdministrativa', display: 'Pendência administrativa', quantidade: 0 },
        { key: 'pendente', display: 'Pendência médica', quantidade: 0 },
        { key: 'pendenciaRespondida', display: 'Pendência respondida', quantidade: 0 },
        { key: 'novaSolicitacaoParticular', display: 'Nova solicitação particular', quantidade: 0 },
        { key: 'cancelamentoSolicitado', display: 'Cancelamento solicitado', quantidade: 0 },
        { key: 'orcamentoAprovado', display: 'Orçamento aprovado', quantidade: 0 },
        { key: 'aguardandoReservaHis', display: 'Aguardando reserva no HIS', quantidade: 0 },
        { key: 'aguardandoAlteracaoDeReservaHis', display: 'Aguardando alteração de reserva no HIS', quantidade: 0 },
        { key: 'erroReservaHis', display: 'Erro ao reservar no HIS', quantidade: 0 },
        { key: 'erroAoAlterarReservaHis', display: 'Erro ao alterar reserva no HIS', quantidade: 0 },
        { key: 'incompleta', display: 'Em edição', quantidade: 0 },
        { key: 'cancelada', display: 'Cancelada', quantidade: 0 },
      ])
    }

    status = [
      ...this.etapasBase,
      ...status,
    ]
    return status
  }

  getTableHeaders() {
    const headers = localStorage.getItem('backoffice-fidelizacao-table-headers')
    this.headers = headers ? JSON.parse(headers) : this.headers
  }

  saveHeaders() {
    (localStorage as any).setItem('backoffice-fidelizacao-table-headers', JSON.stringify(this.headers, null, 2))
  }

  async init() {
    try {
      this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
      this.BackofficeFidelizacaoStore.clearSurgerySolicitations()

      const httpResponseData = await this.BackofficeFidelizacaoStore.loadAgendamentosMedicoSearch()
      if (!httpResponseData.success) {
        EventBus.$emit('setSnackbar', { show: true, text: httpResponseData.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
      }

      const regionalRes = await AgendamentoBackofficeApi.getAllAgrupadorHospitaByUsuario('Regional')
      if (regionalRes.success) {
        this.regionalFilterOptions = regionalRes.data!
      }

      const especialidadeRes = await CadastroApi.getCbosAll()
      if (especialidadeRes.success) {
        this.especialidadeFilterOptions = especialidadeRes.data!
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    } finally {
      this.clearLoadingRequest()
    }
  }

  created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
  }

  destroyed() {
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.ctrlKey && event.code === 'Space' && !!this.showAdvancedFilters) this.showAdvancedFilters()
    if (event.ctrlKey && event.altKey && event.code === 'Space' && !!this.clearAdvancedFilters) this.clearAdvancedFilters()
  }

  setLoadingRequest(status: boolean, text: string) {
    this.loadingRequest = { status, text }
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  async clearAdvancedFilters() {
    this.BackofficeFidelizacaoStore.clearFiltro()
    this.BackofficeFidelizacaoStore.setFilterOn(false)
    this.drawer = false
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.BackofficeFidelizacaoStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }


  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get BackofficeFidelizacaoStore() {
    return getModule(BackofficeFidelizacaoStore, this.$store)
  }

  get getHistoricoSolicitacaoStore() {
    return getModule(HistoricoSolicitacaoStore, this.$store)
  }

  get solicitacoes() {
    return this.BackofficeFidelizacaoStore.solicitacoes
  }

  get etapa() {
    return this.BackofficeFidelizacaoStore.fidelizationStatus
  }

  get canShowFilterByStatus() {
    return permissionService.hasPermission('agendamento.backoffice.fidelizacao.filtrarPorStatus')
  }

  get canShowAdvancedFilters() {
    return permissionService.hasPermission('agendamento.backoffice.fidelizacao.filtrosAvancados')
  }

  get canShowFilterByProtocoloProductLine() {
    return permissionService.hasPermission('agendamento.backoffice.protocolo.visualizarProductLine')
  }

  set etapa(value: any) {
    this.BackofficeFidelizacaoStore.addFidelizationStatus(value.key)
  }

  get etapas() {
    return [
      { key: 'ProtocoloAderente', display: 'Protocolo aderente' },
      { key: 'ProtocoloNaoAderente', display: 'Protocolo não aderente' },
      { key: 'FidelizacaoAceitouJustificativa', display: 'Fidelização aceitou justificativa' },
      { key: 'PendenciaDeProtocolo', display: 'Pendência de protocolo' },
      { key: 'ProtocoloAceito', display: 'Protocolo aceito' },
      { key: 'ProtocoloRecusado', display: 'Protocolo recusado' },
      { key: 'EncaminhadoPelaRegulacao', display: 'Encaminhado pela regulação' },
      { key: 'PendenciaDeProtocoloExpirada', display: 'Pendência de protocolo expirada' },
      { key: 'AutorizadaPelaRegulacao', display: 'Autorizada pela regulação' },
      { key: 'AutorizadaParcialPelaRegulacao', display: 'Autorizada parcial pela regulação' },
      { key: 'AutorizacaoNegadaPelaRegulacao', display: 'Autorização negada pela regulação' },
    ]
  }

  get categoriaDoPlanoParaFidelizacaoFilter() {
    return this.BackofficeFidelizacaoStore.categoriaDoPlanoParaFidelizacao
  }

  set categoriaDoPlanoParaFidelizacaoFilter(value: any[]) {
    this.BackofficeFidelizacaoStore.setCategoriaDoPlanoParaFidelizacao(value)
  }

  get categoriaDoPlanoParaFidelizacaoFilterOptions() {
    return [
      { key: 'community', display: 'Community' },
      { key: 'indefinido', display: 'Indefinido' },
      { key: 'outros', display: 'Outros' },
    ]
  }

  async categoriaDoPlanoParaFidelizacaoChange() {
    await this.$nextTick(() => {
      this.filterSituacao()
    })
  }

  get regionalFilter() {
    return this.BackofficeFidelizacaoStore.agrupadorHospital
  }

  set regionalFilter(value: any[]) {
    this.BackofficeFidelizacaoStore.setAgrupadorHospitaisIds(value)
  }

  async regionalFilterChange() {
    await this.$nextTick(() => {
      this.filterSituacao()
    })
  }

  get especialidadeFilter() {
    return this.BackofficeFidelizacaoStore.protocolosEspecialidade
  }

  set especialidadeFilter(value: any[]) {
    this.BackofficeFidelizacaoStore.setProtocolosEspecialidadeIds(value)
  }

  async especialidadeFilterChange() {
    await this.$nextTick(() => {
      this.filterSituacao()
    })
  }

  showAdvancedFilters() {
    this.drawer = !this.drawer
  }

  showAnalysisSurgeryButton(surgerySolicitation): boolean {
    const { acoes: action } = surgerySolicitation
    const { fidelizacaoFazAnaliseDeProtocoloNaoAderente: analysisSurgeryAvailable } = action

    return analysisSurgeryAvailable
  }

  showReadOnlyAction(surgerySolicitation) {
    const { acoes: action } = surgerySolicitation
    const { visualizar: readOnlyAvailable } = action

    return readOnlyAvailable
  }

  get todosOsStatus() {
    return this.BackofficeFidelizacaoStore.todosOsStatus
  }

  set todosOsStatus(value: boolean) {
    this.BackofficeFidelizacaoStore.setTodosOsStatus(value)
  }

  get todosOsStatusDaArea() {
    return this.BackofficeFidelizacaoStore.todosOsStatusDaArea
  }

  set todosOsStatusDaArea(value: boolean) {
    this.BackofficeFidelizacaoStore.setTodosOsStatusDaArea(value)
  }

  get iconTodosOsStatus() {
    return this.todosOsStatus ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  get iconTodosOsStatusDaArea() {
    return this.todosOsStatusDaArea ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'
  }

  get getAguardandoSuprimentosTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.length > 0
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoSuprimentos).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoSuprimentos)[0].quantidade
    }
    return 0
  }

  get getAguardandoOperadoraTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.length > 0
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoOperadora).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AguardandoOperadora)[0].quantidade
    }
    return 0
  }

  get getRetornoDaAutorizacaoDoHisTotal() {
    let countRetornoAutorizacaoPlusRespostaDoRobo = 0

    if (this.BackofficeFidelizacaoStore.situacoesCounter.length > 0 && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RetornoDaAutorizacaoDoHis).length > 0) {
      countRetornoAutorizacaoPlusRespostaDoRobo += this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RetornoDaAutorizacaoDoHis)[0].quantidade
    }

    return countRetornoAutorizacaoPlusRespostaDoRobo
  }

  get getRespostaDoRoboDeAutorizacaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.length > 0
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RespostaDoRoboDeAutorizacao).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.RespostaDoRoboDeAutorizacao)[0].quantidade
    }
    return 0
  }

  get getAutorizadaParcialTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.length > 0
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizadaParcial).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizadaParcial)[0].quantidade
    }
    return 0
  }

  get getAutorizacaoPosTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.length > 0
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizacaoPos).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AutorizacaoPos)[0].quantidade
    }
    return 0
  }

  get getPendenteTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.length > 0
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Pendente).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.Pendente)[0].quantidade
    }
    return 0
  }

  get getPendenciaRespondidaTotal() {
    if (this.BackofficeFidelizacaoStore
      .situacoesCounter.some(c => c.key === SituacaoEnum.PendenciaRespondida)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenciaRespondida).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.PendenciaRespondida)[0].quantidade
    }
    return 0
  }

  get getEmCotacaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.EmCotacao)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.EmCotacao).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.EmCotacao)[0].quantidade
    }
    return 0
  }

  get getAnalisePreAutorizacaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.AnalisePreAutorizacao)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreAutorizacao).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreAutorizacao)[0].quantidade
    }
    return 0
  }

  get getAnalisePreCotacaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.AnalisePreCotacao)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreCotacao).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePreCotacao)[0].quantidade
    }
    return 0
  }

  get getRevisaoCirurgicaAutorizacaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.RevisaoCirurgicaAutorizacao)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.RevisaoCirurgicaAutorizacao).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.RevisaoCirurgicaAutorizacao)[0].quantidade
    }
    return 0
  }

  get getAnalisePosCotacaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.AnalisePosCotacao)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePosCotacao).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.AnalisePosCotacao)[0].quantidade
    }
    return 0
  }

  get getPendenteDeEnvioRoboDeAutorizacaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.PendenteDeEnvioRoboDeAutorizacao)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteDeEnvioRoboDeAutorizacao).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteDeEnvioRoboDeAutorizacao)[0].quantidade
    }
    return 0
  }

  get getPendenteDeEnvioRoboDeDaAutorizacaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.PendenteDeEnvioRoboDeAutorizacao)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteDeEnvioRoboDeAutorizacao).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.PendenteDeEnvioRoboDeAutorizacao)[0].quantidade
    }
    return 0
  }

  get getAutorizadaTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.Autorizada)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Autorizada).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.Autorizada)[0].quantidade
    }
    return 0
  }

  get getContestacaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.ContestacaoMedica)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.ContestacaoMedica).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.ContestacaoMedica)[0].quantidade
    }
    return 0
  }

  get getContestacaoPendenteTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.ContestacaoPendente)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.ContestacaoPendente).length > 0) {
      return this.BackofficeFidelizacaoStore
        .situacoesCounter.filter(c => c.key === SituacaoEnum.ContestacaoPendente)[0].quantidade
    }
    return 0
  }

  get getEmEdicaoTotal() {
    if (this.BackofficeFidelizacaoStore.situacoesCounter.some(c => c.key === SituacaoEnum.Incompleta)
      && this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Incompleta).length > 0) {
      return this.BackofficeFidelizacaoStore.situacoesCounter.filter(c => c.key === SituacaoEnum.Incompleta)[0].quantidade
    }
    return 0
  }

  async selectAllFromHospital() {
    await this.$nextTick(() => {
      this.todosOsStatus = !this.todosOsStatus
      this.filterBySurgeryStatus()
    })
  }

  async selectAllFromArea() {
    await this.$nextTick(() => {
      this.todosOsStatusDaArea = !this.todosOsStatusDaArea
      this.filterBySurgeryStatus()
    })
  }

  async selectSituacao(item: any) {
    if (this.todosOsStatus || this.todosOsStatusDaArea) {
      this.todosOsStatus = false
      this.todosOsStatusDaArea = false
      this.BackofficeFidelizacaoStore.clearSituacoes()
    }

    this.surgerySolicitationStatus = item

    await this.$nextTick(() => {
      this.filterSituacao()
    })
  }

  async filterBySurgeryStatus() {
    this.BackofficeFidelizacaoStore.clearPagePagination()
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.BackofficeFidelizacaoStore.loadAgendamentosMedicoSearch()
    this.clearLoadingRequest()
  }

  get getAllEtapas() {
    return this.etapa.length === this.etapas.length
  }

  get getSomeEtapas() {
    return this.etapa.length > 0 && !this.getAllEtapas
  }

  get icon() {
    let stepIcon = ''

    if (this.getAllEtapas) {
      stepIcon = 'mdi-checkbox-marked'
    } else {
      stepIcon = 'mdi-checkbox-blank-outline'
    }

    return stepIcon
  }

  async filterByAllFidelizationStatuses() {
    await this.$nextTick(() => {
      if (this.etapa.length === this.etapas.length) {
        this.BackofficeFidelizacaoStore.clearFidelizationStatuses()
        this.filterSituacao()
      } else {
        this.BackofficeFidelizacaoStore.setAllFidelizationStatuses()
        this.filterSituacao()
      }
    })
  }

  async filterByFidelizationStatus(item: any) {
    this.etapa = item
    await this.$nextTick(() => {
      this.filterSituacao()
    })
  }

  async filterSituacao() {
    try {
      this.BackofficeFidelizacaoStore.clearPagePagination()
      this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)

      const httpResponseData = await this.BackofficeFidelizacaoStore.loadAgendamentosMedicoSearch()

      if (!httpResponseData.success) {
        EventBus.$emit('setSnackbar', { show: true, text: httpResponseData.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    } finally {
      this.clearLoadingRequest()
    }
  }

  get getTotal() {
    return this.BackofficeFidelizacaoStore.totalSolicitacoes || 0
  }

  async openReadOnlyModal(agendamentoCirurgia: AgendamentoCirurgia) {
    this.readOnlyLoading = agendamentoCirurgia.id

    this.getBackofficeGlobalStore.setBackofficeArea(backofficeRoute())
    this.getBackofficeGlobalStore.setSolicitacaoId(agendamentoCirurgia.id)
    this.getBackofficeGlobalStore.setModal({ name: 'visualizacao', value: true })

    this.ga('backoffice-orcamento', 'visualizar-aguardando-orcamento')
    this.readOnlyLoading = false
  }

  getTableRowClasses(data: AgendamentoSolicitacaoItem) {
    const classes: string[] = []

    if (data.carater.key === 'Urgencia') {
      classes.push('table-row__danger')
    }

    if (data.auditada && this.$user.profile.roles.includes('auditoria') && ['BackofficeAutorizacao', 'BackofficeAgendamento'].includes(this.$route.name!)) {
      classes.push('auditada')
    }

    return classes
  }

  displayCorSituacao(value: string) {
    return displayColorBySituation(value)
  }

  displayCorEtapa(value: string) {
    return displayColorByStatus(value)
  }

  slaColor(statusSla: StatusSlaEnum) {
    switch (statusSla) {
      case StatusSlaEnum.Normal:
        return 'green'

      case StatusSlaEnum.Alerta:
        return 'yellow'

      case StatusSlaEnum.Critico:
        return 'red'

      default:
        return ''
    }
  }

  get displayCategoriaDoPlanoParaFidelizacao() {
    return displayCategoriaDoPlanoParaFidelizacao
  }

  async showHistory(solicitacaoId: string) {
    this.loadingHistorico = solicitacaoId
    await this.getHistoricoSolicitacaoStore.getHistoricoSolicitacao(solicitacaoId)
    this.loadingHistorico = ''
  }

  get getCurrentPage() {
    return this.BackofficeFidelizacaoStore.pagina
  }

  set getCurrentPage(value: number) {
    this.BackofficeFidelizacaoStore.setPagina(value)
  }

  get getQtdPorPagina() {
    return this.BackofficeFidelizacaoStore.qtdPorPagina
  }

  set getQtdPorPagina(value: number) {
    this.BackofficeFidelizacaoStore.setQtdPorPagina(value)
  }

  get getTotalSolicitacoes() {
    return this.BackofficeFidelizacaoStore.totalSolicitacoes
  }

  get pagesCounter() {
    return Math.ceil(this.getTotalSolicitacoes / this.getQtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  async getResults(page: number) {
    try {
      this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
      this.getCurrentPage = page

      const httpResponseData = await this.BackofficeFidelizacaoStore.loadAgendamentosMedicoSearch()

      if (!httpResponseData.success) {
        EventBus.$emit('setSnackbar', { show: true, text: httpResponseData.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    } finally {
      this.clearLoadingRequest()
    }
  }

  get surgerySolicitationStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  async mounted() {
    await this.init()
    this.readyState = true
    this.getTableHeaders()
    EventBus.$on('setLembrete', value => this.BackofficeFidelizacaoStore.setLembreteStatus(value))
  }

  async openAnalysisSurgerySolicitation(agendamentoCirurgia: AgendamentoCirurgia) {
    try {
      const surgerySolicitationId = agendamentoCirurgia.id
      this.getBackofficeGlobalStore.setHospitalId(agendamentoCirurgia.hospitalId)
      this.analysisSurgeryLoading = surgerySolicitationId

      const blockSurgerySolicitationAPIRequest = await this.BackofficeFidelizacaoStore.blockFidelizationSurgerySolicitation(surgerySolicitationId)

      if (blockSurgerySolicitationAPIRequest.success) {
        const retrieveSurgerySolicitationAPIRequest = await this.getBackofficeGlobalStore.getSolicitacaoById(surgerySolicitationId)

        await this.BackofficeFidelizacaoStore.getAllSurgerySolicitationProtocols(this.getBackofficeGlobalStore.solicitacao)

        if (retrieveSurgerySolicitationAPIRequest.success) {
          await this.getBackofficeGlobalStore.getHospitalTemplate(agendamentoCirurgia.hospitalId)
          this.getBackofficeGlobalStore.setModal({ name: 'fidelizacao', value: true })
        } else {
          EventBus.$emit('setSnackbar', { show: true, text: retrieveSurgerySolicitationAPIRequest.message || 'Erro ao abrir solicitação', icon: 'warning', color: '#C62828' })
        }
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: blockSurgerySolicitationAPIRequest.message || 'Solicitação já está em atendimento', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível concluir a operação', icon: 'warning', color: '#C62828' })
    } finally {
      this.ga('operadora-fidelizacao', 'analisar-fidelizacao')
      this.analysisSurgeryLoading = ''
    }
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  loadAllSolicitacoes: boolean = false

  get loadingAllSolicitacoes() { return this.loadAllSolicitacoes }
  set loadingAllSolicitacoes(value: boolean) { this.loadAllSolicitacoes = value }

  async reloadSurgerySolicitationsList() {
    try {
      this.loadingAllSolicitacoes = true

      const httpResponseData = await this.BackofficeFidelizacaoStore.loadAgendamentosMedicoSearch()

      if (!httpResponseData.success) {
        EventBus.$emit('setSnackbar', { show: true, text: httpResponseData.message || 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro ao buscar as solicitações', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingAllSolicitacoes = false
    }
  }

  beforeDestroy() {
    this.BackofficeFidelizacaoStore.clearFidelizationStatuses()
  }
}
